let currentSystemId = '0';

export default {
  currentSystemId
}



// WEBPACK FOOTER //
// ./src/store/data_system.js